<p>edit-truck-inline works!</p>
